export default __webpack_public_path__ + "static/media/login_bg.5ca51658.jpg";